import { render, staticRenderFns } from "./InnerList.vue?vue&type=template&id=63c77034&scoped=true&"
import script from "./InnerList.vue?vue&type=script&lang=js&"
export * from "./InnerList.vue?vue&type=script&lang=js&"
import style0 from "./InnerList.vue?vue&type=style&index=0&id=63c77034&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c77034",
  null
  
)

export default component.exports